import {
  externalConnectionCalendarsConverter,
  getExternalConnectionCalendarsDoc as _getExternalConnectionCalendarsDoc,
} from '@griply/services';
import { ExternalConnectionCalendarsCache } from '@griply/types';
import {
  doc,
  DocumentReference,
  FirestoreDataConverter,
  getFirestore,
} from 'firebase/firestore';
import { ID } from 'shared/types/id';

// cast: FirestoreDataConverter is invariant on the snapshot type the shared converter keeps structural
const converter =
  externalConnectionCalendarsConverter as unknown as FirestoreDataConverter<ExternalConnectionCalendarsCache>;

export const getExternalConnectionCalendarsDoc = (externalConnectionId: ID) =>
  _getExternalConnectionCalendarsDoc<
    DocumentReference,
    ReturnType<typeof getFirestore>
  >({
    externalConnectionId,
    db: getFirestore(),
    doc,
  }).withConverter(converter);
